module.exports = __webpack_public_path__ + "img/dice6.497ca2cd.svg";